import { METHOD, webRequest } from '../../client/HttpClient';
import { API } from '../../client/RouteConstants';
import { buildURL, logAPIErrorToNewrelic } from '../utils';
import { ACTION, Analytics } from '../../analytics/analytics';
import { APIResult } from '../APIResult';

export const deleteWishListSku = async (skuId: string): Promise<APIResult<WishListItem[]>> => {
    const url = buildURL(`${API.WISH_LISTS}/items/${skuId}?productMode=true&includesImages=true`);

    const request: RequestInit = {
        method: METHOD.DELETE,
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    };

    const res = await webRequest(url, request);

    const result = new APIResult<WishListItem[]>();
    if (!res) {
        logAPIErrorToNewrelic(`deleteWishListSku`, `No response`, {
            skuId,
            ...request,
            url: url,
            response: res,
        });
        return result;
    }

    if (res.status === 401) {
        result.showError = false;
    }

    if (res.ok) {
        Analytics.dispatchAdobeAnalytics(ACTION.REMOVE_FROM_WISH_LIST);
        const customEvent = new CustomEvent('ADD_TO_WISHLIST_ESI:REMOVE_SUCCESS', {
            detail: {
                code: 'wishlist remove success',
            },
        });
        window.dispatchEvent(customEvent);
        result.data = ((await res.json()) as WishlistResponse).wishLists;
        result.success = true;
    } else {
        logAPIErrorToNewrelic(`deleteWishListSku`, `Not Ok response`, {
            skuId,
            request: request,
            reqUrl: url,
            ...res,
        });
    }

    return result;
};
